// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"0b948899","453":"edc663b4","484":"23130354","551":"7a14b980","851":"c8b32e85"}[chunkId] + ".chunk.js";
};